/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_6220f06a"]'><cube-tab-bar :value="selectedLabelSlots" mpxModelEvent="input" :tabs="(tabs)" show-slider custom-content @_click="clickHandler" @mpxModel='(e)=>__invoke(e, [["__model","selectedLabelSlots", "__mpx_event__", ["value"], undefined]])' @change='(e)=>__invoke(e, [["changeHandler"]])'><cube-tab v-for="(item, index) in (tabs)" :key="item.label" :icon="(item.icon)" :label="(item.label)" :value="(item.value)" :class='["cube-tab"]'></cube-tab></cube-tab-bar></div></template>
/* styles */
/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_6220f06a"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_6220f06a"}
  /** script content **/
  require("./tab-bar-slider.mpx.js?isComponent&outputPath=components%2Ftab-bar-slider6220f06a%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./tab-bar-slider.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Ftab-bar-slider6220f06a%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_6220f06a"],
    ctorType: "component",
    outputPath: "components/tab-bar-slider6220f06a/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-tab-bar':getComponent(require("../../../packages/mpx-cube-ui/src/components/tab-bar/index.mpx?isComponent&outputPath=components%2Findexff7d3170%2Findex")),'cube-tab':getComponent(require("../../../packages/mpx-cube-ui/src/components/tab-bar/tab.mpx?isComponent&outputPath=components%2Ftab66c6e44b%2Findex")),'cube-icon':getComponent(require("../../../packages/mpx-cube-ui/src/components/icon/index.mpx?isComponent&outputPath=components%2Findex1d853680%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>